module.exports = __webpack_public_path__ + "static/media/orders.a407f216.svg";